module.exports = __webpack_public_path__ + "static/img/hotelface.4f893dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BarndGlht/hotelface.png
// module id = 1104
// module chunks = 18